import { FC } from 'react';
import { clsx } from 'clsx';
import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import './TaskRangeFilter.scss';
import { taskSidebarFiltersAtom } from '../../../../data-access';

export type TaskRangeOption = 'all' | 'today' | 'this_week' | 'overdue' | 'backlog';

const RANGE_OPTIONS: { value: TaskRangeOption; labelKey: string }[] = [
  { value: 'all', labelKey: 'task.filters.views.all' },
  { value: 'today', labelKey: 'task.filters.views.today' },
  { value: 'this_week', labelKey: 'task.filters.views.thisWeek' },
  { value: 'overdue', labelKey: 'task.filters.views.overdue' },
  { value: 'backlog', labelKey: 'task.filters.views.backlog' },
];

const TaskRangeFilter: FC = () => {
  const { t } = useTranslation();
  const [filters, setFilters] = useRecoilState(taskSidebarFiltersAtom);

  const handleRangeChange = (value: TaskRangeOption) => {
    setFilters((prev) => ({ ...prev, view: value }));
  };

  return (
    <FormGroup className="task-range-filter">
      {RANGE_OPTIONS.map((option) => {
        const isSelected = filters.view === option.value;
        return (
          <FormControlLabel
            key={option.value}
            className={clsx('task-range-filter__item', {
              'task-range-filter__item--selected': isSelected,
            })}
            control={
              <Checkbox
                size="small"
                checked={isSelected}
                onChange={() => handleRangeChange(option.value)}
              />
            }
            label={
              <Typography variant="body2" className="task-range-filter__item__text">
                {t(option.labelKey)}
              </Typography>
            }
          />
        );
      })}
    </FormGroup>
  );
};

export default TaskRangeFilter;
